<template>
  <div>
    <div v-if="dose.dt_aplicacao_br != null">
      {{ dose.dt_aplicacao_br }}
      <i
        :class="dose.dt_aplicacao_br != null ? 'icofont-check-circled' : ''"
        :style="{
          color: dose.dt_aplicacao_br != null ? 'green' : '',
        }"
      ></i>
      <br />
      com {{ dose.meses }} meses
      <span
        v-if="dose.dose_anterior == 1"
        v-b-tooltip.hover.right
        title="Dose registrada como transcrição de caderneta."
        class="icon-tooltip"
      >
        <i class="icofont-info-circle"></i>
      </span>
    </div>
    <div v-else>
      <div v-if="item.idade_meses >= meses">
        Falta
        <i class="icofont-close-circled" style="color: red"></i>
      </div>
      <div v-else></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: [Object, Boolean],
      default: false,
    },
    dose: {
      type: [Object, Boolean],
      default: false,
    },
    dosePendente: {
      type: [Object, Boolean],
      default: false,
    },
    meses: {
      type: Number,
      default: 0,
    },
  },
}
</script>

<style></style>
